import type { ProductNicotineStrength } from "@jti/magento";
import { FormattedPrice, useTranslations } from "@jti/ui";
import { StrengthIndicator } from "@jti/ui/components/StrengthIndicator";

import styles from "./ProductLineItem.module.scss";

export interface ProductLineItemProps {
  thumbnail: {
    src: string;
    alt: string;
  };
  title: string;
  spec?: string;
  badge?: string;
  quantity: number;
  price: {
    value: number;
    currency: string;
  };
  nicotineStrength?: ProductNicotineStrength;
}

export const ProductLineItem = ({
  thumbnail,
  title,
  spec,
  badge,
  quantity,
  price,
  nicotineStrength,
}: ProductLineItemProps) => {
  const { __ } = useTranslations();

  return (
    <div className={styles.container}>
      <div className={styles.thumbnail}>
        <img src={thumbnail.src} alt={thumbnail.alt} />
      </div>
      <div className={styles.itemDetails}>
        <div className={styles.details}>
          <p className={styles.title}>{title}</p>
          {nicotineStrength && <StrengthIndicator name={nicotineStrength.name} strength={nicotineStrength.rating} />}
          {badge && <span className={styles.badge}>{__(badge)}</span>}
          {spec && <p className={styles.spec}>{spec}</p>}
        </div>
        <div className={styles.priceDetails}>
          <div className={styles.quantityWrapper}>
            <p className={styles.quantityText}>{__("cart.payment_items_summary.quantity", [quantity])}</p>
          </div>
          <div className={styles.price}>
            <FormattedPrice currency={price.currency} value={price.value} className={styles.mainPrice} />
          </div>
        </div>
      </div>
    </div>
  );
};
